import React, { useEffect, useState, useRef }  from 'react';
import { RiArrowDownSLine } from "react-icons/ri";
import './customSelect.scss'
import { useChanges } from "../../../hooks/useChanges";

const CustomSelectDefaultStyle = ({ selectedValue, setSelectedValue, keyName }) => {
    const { addChangeToStore } = useChanges();
    const [isOpenList, setIsOpenList] = useState(false);
    const [isDisplay, setIsDisplay ] = useState(false);
    const selectRef = useRef();

    const selectVar = useState([
        {
            name: 'Classic Captcha',
        },
        {
            name: 'Numerical Captcha',
        },
        {
            name: 'Images Captcha',
            subscr: 'pro'
        },
    ])[0];


    useEffect(() => {
        if (isOpenList) {
            setIsDisplay(true);
        } else {
            setTimeout(() => {
                setIsDisplay(false);
            }, 400);
        }
    }, [isOpenList]);

    // Обробник для закриття селекту при кліці за його межами
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpenList(false);
            }
        };

        if (isOpenList) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenList]);

    // Функція для вибору значення і закриття селекту
    const handleSelect = (value) => {
        setSelectedValue(value);
        addChangeToStore({key: keyName, value: value.split(' ')[0].toLowerCase(), data: {[keyName]: value.split(' ')[0].toLowerCase()}})
        setIsOpenList(false);
    }

    return (
        <div className='custom_select_wraper' ref={selectRef}>
            <div className='custom_select_value' onClick={() => setIsOpenList(state => !state)}>
                <p>{selectedValue}</p>
                <RiArrowDownSLine className={`custom_select_value_var_img ${isOpenList && 'custom_select_value_var_open_img'}`} />
            </div>
            <div className={`custom_select_value_var ${isOpenList && 'custom_select_value_var_open'} ${!isDisplay ? 'custom_select_value_var_close_none' : ''}`}>
                <p>TYPE</p>
                {selectVar.map((item, idx) => (
                    <div onClick={() => handleSelect(item.name)} className='custom_select_value_var_item'>
                        <p>{item.name} {item.subscr && <label htmlFor="">PRO</label> } </p>
                        {selectedValue === item.name && 
                        <svg className='svg_select_var' xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
                        <path d="M3.64032 5.59282C3.60557 5.62776 3.56426 5.65549 3.51876 5.67442C3.47326 5.69334 3.42447 5.70308 3.37519 5.70308C3.32591 5.70308 3.27712 5.69334 3.23162 5.67442C3.18612 5.65549 3.14481 5.62776 3.11007 5.59282L0.992817 3.47519C0.887365 3.36971 0.828125 3.22666 0.828125 3.0775C0.828125 2.92835 0.887365 2.7853 0.992817 2.67982L1.25794 2.41469C1.36343 2.30924 1.50648 2.25 1.65563 2.25C1.80478 2.25 1.94783 2.30924 2.05332 2.41469L3.37519 3.73657L6.94707 0.164692C7.05255 0.0592398 7.1956 0 7.34476 0C7.49391 0 7.63696 0.0592398 7.74244 0.164692L8.00757 0.429817C8.11302 0.535302 8.17226 0.67835 8.17226 0.827505C8.17226 0.97666 8.11302 1.11971 8.00757 1.22519L3.64032 5.59282Z" fill="#839FF7"/>
                        </svg>} 
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomSelectDefaultStyle;